class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      console.log("ad");
      /* Drawer remove then Quantity update */
       setTimeout(function(){
         
           jQuery(".instant_saving_cart_item_block .product_variant_block, .instant_saving_cart_item_block .cart-btn").hover(
              function() {
                jQuery(this).closest(".card_product_variant").addClass("show_var");
              },
              function() {
                jQuery(".card_product_variant").removeClass("show_var");
              }
            );


            jQuery(".variant-button").click(function () {
              var vals = jQuery(this).prev('input[name="id"]').attr('data-variant-id');
              console.log("valss:" + vals);
              var qty = jQuery(this).parents(".card__information").find('input[name="quantity"]').val();
              console.log("qtys:" + qty);
      
              jQuery.ajax({
                  type: "POST",
                  url: "/cart/add.js",
                  data: {
                      "id": vals,
                      "quantity": qty
                  },
                 
                   success: function(){ 
                 
                     jQuery("body").addClass("overflow-hidden");
                     jQuery('cart-drawer').removeClass('is-empty');
                      jQuery('.drawer__inner-empty').hide();
                      jQuery('cart-drawer').load(location.href + " #CartDrawer");
                      jQuery(".cart_item_clear_btn").addClass("active");
      
                     jQuery('cart-drawer').addClass('overlay');
                      
                      // Set a timeout to remove the class after 5 seconds
                      setTimeout(function () {
                      	jQuery('cart-drawer').removeClass('overlay');
                      }, 5000);
                     
                     setTimeout(function(){
                          jQuery('cart-drawer').load(location.href + " #CartDrawer");
                          jQuery(".cart_item_clear_btn").addClass("active");
                          jQuery(".drawer").addClass('active animate');
                          jQuery(".drawer__header").click(function(e){
                            e.preventDefault();
                            console.log("adsasdasd");
                          });
      
                          setTimeout(function(){
                         jQuery(".instant_saving_cart_item_block .product_variant_block, .instant_saving_cart_item_block .cart-btn").hover(
                            function() {
                              jQuery(this).closest(".card_product_variant").addClass("show_var");
                            },
                            function() {
                              jQuery(".card_product_variant").removeClass("show_var");
                            }
                          );
                          }, 500); 
        
                         jQuery.getJSON('/cart.js', function(cart){ 
                           var result = cart.item_count;
                          console.log('main' + result);
                           jQuery(".header__icon--cart .cart-count-bubble > span").text(result);
      
                           jQuery(".instant_saving_cart_item_block .product_variant_block, .instant_saving_cart_item_block .cart-btn").hover(
                            function() {
                              jQuery(this).closest(".card_product_variant").addClass("show_var");
                            },
                            function() {
                              jQuery(".card_product_variant").removeClass("show_var");
                            }
                          );
                           
                         });
                      },500); 
                  },
                  error: function () {
                      console.log("error");
                  }
              });
          });
         
           jQuery(".cart-quantity").change(function() {
              var variantId = jQuery(this).find("option:selected").attr("data-variant-id");
              var quantity = jQuery(this).val();
          
              // Check if the quantity is 0 or less, and remove the item if true
              if (parseInt(quantity) <= 0) {
                  jQuery.ajax({
                      type: "POST",
                      url: "/cart/update.js",
                      data: {
                          "updates": {
                              [variantId]: 0 // Set the quantity to 0 to remove the item
                          }
                      },
                      success: function() {
                        
                        jQuery("body").addClass("overflow-hidden");
                          // Handle success, e.g., update the UI
                          console.log("Product removed from the cart");
                      },
                      error: function() {
                          console.log('Error removing product from the cart');
                      }
                  });
              } else {
                  // Quantity is greater than 0, perform the regular quantity update
                  jQuery.ajax({
                      type: "POST",
                      url: "/cart/update.js",
                      data: {
                          "updates": {
                              [variantId]: quantity
                          }
                      },
                      success: function() {
                          // Handle success, e.g., update the UI
                        //$('cart-drawer').load(location.href + " #CartDrawer");
                        jQuery("body").addClass("overflow-hidden");
                        setTimeout(function(){
                          console.log("Quantity updated in the cart");
                          jQuery.getJSON('/cart.js', function(cart){ 
                           var result = cart.item_count;
                           console.log(result);
                           jQuery(".header__icon--cart .cart-count-bubble > span").text(result);
                           jQuery(".cart-drawer .drawer__heading .price_count").text(result);
                          
                         });
                          
                        }, 500);
                      },
                      error: function() {
                          console.log('Error updating quantity in the cart');
                      }
                  });
              }
          });
        }, 2500);
      
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

   //  console.log("quantity update");
   // $(".cart-quantity").change(function() {
   //    console.log("updated");
   //            var variantId = $(this).find("option:selected").attr("data-variant-id");
   //            var quantity = $(this).val();
          
   //            // Check if the quantity is 0 or less, and remove the item if true
   //            if (parseInt(quantity) <= 0) {
   //                $.ajax({
   //                    type: "POST",
   //                    url: "/cart/update.js",
   //                    data: {
   //                        "updates": {
   //                            [variantId]: 0 // Set the quantity to 0 to remove the item
   //                        }
   //                    },
   //                    success: function() {
   //                        // Handle success, e.g., update the UI
   //                        console.log("Product removed from the cart");
   //                    },
   //                    error: function() {
   //                        console.log('Error removing product from the cart');
   //                    }
   //                });
   //            } else {
   //                // Quantity is greater than 0, perform the regular quantity update
   //                $.ajax({
   //                    type: "POST",
   //                    url: "/cart/update.js",
   //                    data: {
   //                        "updates": {
   //                            [variantId]: quantity
   //                        }
   //                    },
   //                    success: function() {
   //                        // Handle success, e.g., update the UI
   //                      //$('cart-drawer').load(location.href + " #CartDrawer");
                        
   //                        console.log("Quantity updated in the cart");
   //                        $.getJSON('/cart.js', function(cart){ 
   //                         var result = cart.item_count;
   //                         console.log(result);
   //                         $(".header__icon--cart .cart-count-bubble > span").text(result);
   //                       });
                        
   //                    },
   //                    error: function() {
   //                        console.log('Error updating quantity in the cart');
   //                    }
   //                });
   //            }
   //        });
    
      jQuery('.one-timee').slick({
        dots: false,
        arrows: false, 
        autoplay:false,
        draggable: false,
        infinite:false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></button>',
        nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></button>',
        adaptiveHeight: false
      });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
